import * as React from "react";
import { useEffect } from "react";
import PdfViewer from "awesome-pdf-viewer";
import Main from "awesome-pdf-viewer/dist/layout/Main";
import Zoom from "awesome-pdf-viewer/dist/toolbar/Zoom";
import Header from "awesome-pdf-viewer/dist/layout/Header";
import Toolbar from "awesome-pdf-viewer/dist/toolbar/Toolbar";
import ViewPanel from "awesome-pdf-viewer/dist/layout/ViewPanel";
import Pagination from "awesome-pdf-viewer/dist/toolbar/Pagination";
import { PdfSource } from "awesome-pdf-viewer/dist/viewer/ViewerBase";
import { DownloadIcon } from "src/assets/images/svg/IconCollection";
import "awesome-pdf-viewer/dist/index.css";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "src/store";
import { downloadUploadedFile } from "src/actionCreators/documentRequestActionCreators";
import { ColorConstants } from "src/assets/custom/colors";

export const FileViewer: React.FC = ()  => {
    const documentState = useSelector((state: ApplicationState) => state.previewDocumentState);
    const dispatch = useDispatch();
    let _viewPanel: any;
    let _toolbar: any;
    useEffect(() => {
        documentState.previewFileDetails.fileType && documentState.previewFileDetails.fileType.toLowerCase() === "pdf" ? setToolbarReferences() : null;
    }, [documentState.previewFileDetails.fileType]);

    const setToolbarReferences = () => {
        _toolbar.setViewerReference(_viewPanel);
        _viewPanel.setToolbarReference(_toolbar);
    };

    const openSaasLinkInNewTab = (link: string) => {
        window.open(link, "_blank");
    };

    return (
        <PdfViewer>
            <Header>
                <Toolbar ref={(ref: any) => (_toolbar = ref)} hideLeftPanel hideRightPanel>
                    <Pagination />
                    <Zoom />
                    <span
                        className="download-icon-file-viewer"
                        onClick={() => {
                            dispatch(
                                downloadUploadedFile(documentState.previewFileDetails.fileName,documentState.previewFileDetails.fileGuid,documentState.previewFileDetails.requestedYear,documentState.previewFileDetails.resourceId,openSaasLinkInNewTab)  )  ;
                        }}
                    >
                        <DownloadIcon width={16} height={16} color={ColorConstants.black} />
                    </span>
                </Toolbar>
            </Header>
            <Main>
                <ViewPanel
                    ref={(ref: any) => (_viewPanel = ref)}
                    pdfSource={PdfSource.createFromUrl(documentState.previewFileDetails.urlData)}
                ></ViewPanel>
            </Main>
        </PdfViewer>
    );
};